
import 'three/examples/js/lines/LineSegments2';
import 'three/examples/js/lines/LineSegmentsGeometry';

import SbpLineVertexShader from '../../shaders/sbp/sbp.vert';
import SbpLineFragmentShader from '../../shaders/sbp/sbp.frag';

import { Palettes, LineTypes } from './SBPVisualizer';

export default class SBPLine extends THREE.LineSegments2 {
  constructor (geometry, width = 3.5) {
    let uniforms = THREE.UniformsUtils.merge([
      THREE.UniformsLib.common,
      {
        t: { value: 1.0 },
        linewidth: { value: width },
        resolution: { value: new THREE.Vector2(1024, 768) },
        mColor: { value: Palettes[LineTypes.MOVE].color },
        jColor: { value: Palettes[LineTypes.JOG].color },
        pColor: { value: Palettes[LineTypes.POCKET].color },
      }
    ]);

    let material = new THREE.ShaderMaterial({
      vertexShader: SbpLineVertexShader,
      fragmentShader: SbpLineFragmentShader,
      transparent: true,
      // depthTest: false,
      depthTest: true,
      depthWrite: false,
      vertexColors: THREE.VertexColors,
      uniforms: uniforms
    });
    material.uniforms.diffuse.value = new THREE.Color(0xffffff);

    super(geometry, material);
  }

  setResolution (w, h) {
    this.material.uniforms.resolution.value.x = w;
    this.material.uniforms.resolution.value.y = h;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/sbp/SBPLine.js